<template>
<div class="page">
  <img src="../../assets/images/invitation/bind_finish.png" alt="" class="bind_finish">
  <div class="tips_text">恭喜您，绑定成功</div>
</div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  components: {
  },
  created () {
  },
  mounted () {
  },
  computed:{
  },
  methods: {
    
  }
}
</script>
<style lang="less" scoped>
.page{
  width: 100%;
  height: 100vh;
  background-color: #ffffff;
  padding-top: 1px;
  .bind_finish{
    width: 445px;
    height: 429px;
    margin: 182px auto 0;
    display: block;
  }
  .tips_text{
    margin-top: 50px;
    width: 100%;
    text-align: center;
    font-size: 36px;
    font-weight: bold;
    color: #333333;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/invitation/bindFinish.vue